import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const RecentActivityList = ({ interviews = [] }) => {
    const navigate = useNavigate();

    const displayData = (interviews || []).slice(0, 10).map(interview => {
        const isPendingResults = interview.is_challenge && interview.include_report && !interview.results_released;
        return {
            icon: interview.type === 'HR' ? 'Users' : 'TerminalSquare',
            title: `${interview.company || 'Technical'} ${interview.type || 'Mock'} Interview`,
            date: new Date(interview.created_at || new Date()).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }),
            topic: interview.role || "General",
            score: isPendingResults ? 'Pending' : `${Math.round(interview.result?.overall_score || interview.result?.overallData?.score || 0)}%`,
            sessionId: interview.session_id,
            isPendingResults
        };
    });

    return (
        <div className="bg-white rounded-2xl border border-slate-200 p-5 shadow-sm">
            <div className="flex items-center justify-between mb-4">
                <h3 className="text-[15px] font-normal text-slate-900">Recent Activity</h3>
                <button 
                    onClick={() => navigate('/profile-progress')}
                    className="text-[13px] font-normal text-emerald-600 hover:text-emerald-700 transition-colors"
                >
                    View History
                </button>
            </div>

            <div className="space-y-3">
                {displayData.length > 0 ? displayData.map((item, idx) => (
                    <div key={idx} className="flex items-center justify-between p-3.5 rounded-xl border border-slate-100 hover:border-slate-200 transition-colors bg-white">
                        <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-xl bg-slate-50 border border-slate-100 flex items-center justify-center shrink-0">
                                <Icon name={item.icon} size={18} className="text-slate-400 stroke-[2.5]" />
                            </div>
                            <div>
                                <h4 className="text-[14px] font-normal text-slate-900 mb-0.5">{item.title}</h4>
                                <p className="text-[11px] font-normal tracking-[0.05em] text-slate-400">
                                    {item.date} • {item.topic}
                                </p>
                            </div>
                        </div>

                        <div className="flex items-center gap-4 shrink-0">
                            <div className="text-right">
                                <p className="text-[17px] font-normal text-emerald-500 leading-none mb-0.5">{item.score}</p>
                                <p className="text-[10px] font-normal tracking-[0.05em] text-slate-400">Score</p>
                            </div>
                            <button
                                onClick={() => item.sessionId ? navigate(`/interview-report?session=${item.sessionId}`) : null}
                                className="bg-emerald-600 hover:bg-emerald-700 text-white font-normal text-[12px] py-1.5 px-4 rounded-[8px] transition-colors"
                            >
                                {item.isPendingResults ? 'View Status' : 'View Report'}
                            </button>
                        </div>
                    </div>
                )) : (
                    <div className="py-6 text-center border border-dashed border-slate-100 rounded-xl">
                         <p className="text-[13px] font-normal text-slate-400">No interviews conducted yet</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default RecentActivityList;
